import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeInvoices } from '@/lib/routes/front/common/routeFrontOfficeInvoices'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeSoundHoldOwner = [
  ...routeFrontOfficeInvoices,
  ...routeFrontOfficeCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISOUND],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_HOLD_OWNER_SOUND],
}))
